import { createBrowserLogger } from '@vzmi/component_ec_nodejs_util/dist/browser-logger'

const minLevel = process.env.NODE_ENV === 'production' ? 'error' : 'log'

export const getLogger = ({ name }) => {
  return createBrowserLogger({ name, minLevel })
}
